import React from "react";
import PropTypes from "prop-types";
import { getString, currencyConvert } from "../../utilities";

export default function PromoBurst({ promo, pRole }) {
  if (promo && promo.planGroups.includes(pRole.toUpperCase())) {
    let offText = getString("promo.title.0");

    if (promo.amountOff > 0) {
      offText = getString("promo.off", [currencyConvert(promo.amountOff)]);
    } else if (promo.percentOff > 0) {
      offText = getString("promo.off", [`${promo.percentOff * 100}%`]);
    }

    return <div className="promo-burst">{offText}</div>;
  }

  return null;
}

PromoBurst.propTypes = {
  pRole: PropTypes.string,
  promo: PropTypes.object,
};

PromoBurst.defaultProps = {
  pRole: undefined,
  promo: null,
};
